import { BaseSurvey } from '../base-survey';
import { EscWebuiUPCampaignFeedbackView } from './view';
import { validateESCTriggerCondition } from '../utils';

export class EscWebuiCampaignFeedbackSurvey extends BaseSurvey {
  getSurveyName = () => 'EscWebuiCampaignFeedbackSurvey';

  getSurveyId = () => '4f304731-345b-47a2-b366-589ad0bba8aa';

  validateTriggerCondition = () => validateESCTriggerCondition(this, 'ESCUserPublishesFirstCampaign');

  onSurveySubmit = () => {
    window.survey.ESCUserPublishesFirstCampaign = false;
  };

  onSurveyDismiss = () => {
    window.survey.ESCUserPublishesFirstCampaign = false;
  };

  getSurveyComponent = () => EscWebuiUPCampaignFeedbackView;
}
